import {Outlet} from 'react-router';
import {Alert, IconButton, useDisclosure} from '@chakra-ui/react';
import {Info} from 'lucide-react';
import {AboutModal} from '../components/AboutModal';
import {LoginPanel} from '../components/LoginPanel';
import {VersionPopup} from '../components/VersionPopup';
import {LandingPage} from '../pages/LandingPage';
import {useAuth} from '../auth/useAuth';

export function AppShell() {
    const {isSignedIn, error} = useAuth();
    const aboutModal = useDisclosure();

    if (!isSignedIn) {
        // Any URL opened without a session lands here; after login the same URL shows what it points to.
        return <LandingPage/>;
    }

    return (
        <>
            <nav className="main-header">
                <img src="/logo_white.png" alt="logo"/>
                <span className="separator"></span>
                <LoginPanel/>
                <IconButton
                    aria-label="Névjegy"
                    title="Névjegy"
                    size="sm"
                    variant="ghost"
                    color="white"
                    _hover={{bg: 'whiteAlpha.200'}}
                    onClick={aboutModal.onOpen}
                >
                    <Info size={20}/>
                </IconButton>
            </nav>
            <main>
                {error &&
                    <Alert.Root status="error" variant="subtle">
                        <Alert.Indicator/>
                        <Alert.Title>{error}</Alert.Title>
                    </Alert.Root>
                }
                <Outlet/>
            </main>
            <VersionPopup/>
            <AboutModal isOpen={aboutModal.open} onClose={aboutModal.onClose}/>
        </>
    );
}
